var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Help } from '@hn-ui/icons';
import { LabelsByAssessmentResult } from '../../constants/texts';
import { AssessmentResultIndicator } from './Indicator';
import { HelpCenterTooltip } from '../Tooltips';
var ScResultLabel = styled.span.withConfig({ displayName: "ScResultLabel", componentId: "sc-hzqqi4" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: ", ";\n  gap: 4px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: ", ";\n  gap: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var ResultLabel = function (_a) {
    var result = _a.result;
    return (_jsxs(ScResultLabel, { children: [_jsx(AssessmentResultIndicator, { result: result }, void 0), _jsx("span", { children: LabelsByAssessmentResult[result] }, void 0), result === 'tbd' && (_jsx(HelpCenterTooltip, { children: _jsx(Help, { color: 'black70', size: 16 }, void 0) }, void 0))] }, void 0));
};
var RESULTS_IN_ORDER = [
    'far_below',
    'below',
    'meets',
    'exceeds',
    'tbd',
];
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-1geruit" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 12px;\n"], ["\n  display: flex;\n  gap: 12px;\n"])));
export var AssessmentResultLegend = function () {
    return (_jsx(ScWrapper, __assign({ "data-testid": 'assessment-result-legend' }, { children: RESULTS_IN_ORDER.map(function (result) { return (_jsx(ResultLabel, { result: result }, result)); }) }), void 0));
};
var templateObject_1, templateObject_2;
